import { Filter, FilterProps } from '@otp/ui';
import { getFilterConfig } from './config';
import { useTranslation } from 'react-i18next';
import { useStores } from 'src/hooks/query/use-stores';
import { useUsers } from 'src/hooks/query/use-users';
import { useDeviceContext } from 'src/context/device.context';
import { useTags } from 'src/hooks/query/use-tags';
import { TagEntityType } from 'src/graphql/generated/graphql';

type IssueTicketsFilterProps = Omit<FilterProps, 'items'> & {
  omitFilterOptions?: string[];
  filterConfigSize?: number;
};

export const IssueTicketsFilter = ({
  omitFilterOptions,
  filterConfigSize,
  ...props
}: IssueTicketsFilterProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list',
  });
  const { isMobile } = useDeviceContext();

  const { users } = useUsers();
  const { tags } = useTags({
    filter: { entityType: TagEntityType.IssueTicket },
  });

  const size = filterConfigSize || (isMobile ? 2 : 3);

  const filterConfig = getFilterConfig({ t, tags, size });
  const filterConfigFiltered = filterConfig.filter(
    (item) => !omitFilterOptions?.includes(item.id),
  );

  return (
    <div className="flex justify-between">
      <Filter
        {...props}
        items={filterConfigFiltered}
        searchInputProps={{
          placeholder: t('filter.search.placeholder'),
        }}
      />
    </div>
  );
};
